import { render, staticRenderFns } from "./CouponEcho.vue?vue&type=template&id=6d8068a1&scoped=true"
import script from "./CouponEcho.vue?vue&type=script&lang=js"
export * from "./CouponEcho.vue?vue&type=script&lang=js"
import style0 from "./CouponEcho.vue?vue&type=style&index=0&id=6d8068a1&lang=less&scoped=true"
import style1 from "./CouponEcho.vue?vue&type=style&index=1&id=6d8068a1&lang=scss"
import style2 from "./CouponEcho.vue?vue&type=style&index=2&id=6d8068a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8068a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8068a1')) {
      api.createRecord('6d8068a1', component.options)
    } else {
      api.reload('6d8068a1', component.options)
    }
    module.hot.accept("./CouponEcho.vue?vue&type=template&id=6d8068a1&scoped=true", function () {
      api.rerender('6d8068a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CCoupon/CouponEcho.vue"
export default component.exports